import { createFileRoute } from '@tanstack/react-router'
import { GenUIAvailabilityCard } from '@/features/ai-assistant/components/genui/availability-card-renderer'

export const Route = createFileRoute('/{-$locale}/_dev/test-availability-card')({
  component: TestAvailabilityCardRoute,
})

const mockResult = {
  success: true,
  stats: { total: 2, cache_hits: 1, cache_misses: 1 },
  data: [
    {
      rst_id: '13000001',
      shopName: 'Sushi Jiro',
      url: 'https://tabelog.com/tokyo/A1301/A130101/13000001/',
      date_list: [
        { date: '2026-05-20', status: 2 },
        { date: '2026-05-21', status: 4 },
        { date: '2026-05-22', status: 2 },
      ]
    },
    {
      rst_id: '13000002',
      shopName: 'Ramen Ichiran',
      url: 'https://tabelog.com/tokyo/A1301/A130101/13000002/',
      date_list: [
        { date: '2026-05-20', status: 4 },
        { date: '2026-05-21', status: 4 },
        { date: '2026-05-22', status: 2 },
      ]
    }
  ]
}

function TestAvailabilityCardRoute() {
  return (
    <div className="p-8 max-w-4xl mx-auto" id="test-container">
      <h1 className="text-2xl font-bold mb-8">Availability Card E2E Test</h1>
      
      <div className="border border-dashed border-gray-300 p-8 rounded-xl bg-gray-50">
        <GenUIAvailabilityCard 
          toolCall={{ toolCallId: 'test-123', args: { results: mockResult.data } }} 
          addToolResult={() => {}} 
        />
      </div>
    </div>
  )
}
